import React, { useState } from 'react';
import {
    Container,
    TextField,
    Button,
    Typography,
    Box,
    Paper
} from '@mui/material';
import axios from 'axios';
import apiUrl from '../../Config';
import { useNavigate } from 'react-router-dom'; 
const LoginPage = () => {
    const [email, setEmail] = useState('john.doe@example.com');
    const [password, setPassword] = useState('yourpassword123');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const navigate = useNavigate(); // initialize useNavigate

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${apiUrl}/employee/login`,
                { email, password },
                { withCredentials: true }
            );

            if (response.data.status) {
                setMessage('Login successful!');
                // Redirect to details page
                navigate('/details');
            } else {
                setMessage(`Login failed: ${response.data.message}`);
            }
        } catch (error) {
            setMessage(`Error: ${error.response?.data?.message || error.message}`);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ padding: 4, mt: 8 }}>
                <Typography variant="h5" component="h1" gutterBottom>
                    Login
                </Typography>

                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        label="Email"
                        type="email"
                        fullWidth
                        required
                        margin="normal"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <TextField
                        label="Password"
                        type="password"
                        fullWidth
                        required
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    {message && (
                        <Typography color={message.startsWith('Login successful') ? 'primary' : 'error'} variant="body2" sx={{ mt: 1 }}>
                            {message}
                        </Typography>
                    )}

                    <Button type="submit" variant="contained" fullWidth sx={{ mt: 3 }}>
                        Login
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default LoginPage;
